/* eslint-disable */
import { useEffect, useState } from 'react';
import { GeoJSON } from 'react-leaflet';
import { GeoJsonObject } from 'geojson';
import { useLayers } from '../../context/LayersContext';

type LayerKey = 'Limite BRA' | 'Estados BRA' | 'Estado PE' | 'Municípios PE';

interface LayerConfig {
  key: LayerKey;
  url: string;
  style: (feature: any) => {
    color: string;
    weight: number;
    fill?: boolean;
    fillOpacity?: number;
  };
}

const LAYER_CONFIGS: LayerConfig[] = [
  {
    key: 'Limite BRA',
    url: 'https://servicodados.ibge.gov.br/api/v4/malhas/paises/BR?resolucao=0&formato=application/vnd.geo+json',
    style: () => ({
      color: '#000000',
      weight: 2,
      fill: false,
    }),
  },
  {
    key: 'Estados BRA',
    url: 'https://servicodados.ibge.gov.br/api/v4/malhas/paises/BR?formato=application/vnd.geo+json&qualidade=maxima&intrarregiao=UF',
    style: () => ({
      color: '#000000',
      weight: 1,
      fill: false,
    }),
  },
  {
    key: 'Estado PE',
    url: 'https://servicodados.ibge.gov.br/api/v4/malhas/estados/26?resolucao=0&formato=application/vnd.geo+json',
    style: () => ({
      color: '#4F4F4F',
      weight: 3,
      fill: false,
    }),
  },
  {
    key: 'Municípios PE',
    url: 'https://servicodados.ibge.gov.br/api/v4/malhas/estados/26?formato=application/vnd.geo+json&qualidade=maxima&intrarregiao=municipio',
    style: () => ({
      color: '#BFBFBF',
      weight: 1,
      fillOpacity: 0.1,
    }),
  },
];

export function RenderUnidadesAdministrativas() {
  const { layers } = useLayers();
  const [dataMap, setDataMap] = useState<
    Record<LayerKey, GeoJsonObject | null>
  >({
    'Limite BRA': null,
    'Estados BRA': null,
    'Estado PE': null,
    'Municípios PE': null,
  });

  useEffect(() => {
    LAYER_CONFIGS.forEach(({ key, url }) => {
      if (layers.includes(key)) {
        if (!dataMap[key]) {
          fetch(url)
            .then((res) => {
              if (!res.ok) throw new Error(`Erro ${res.status}`);
              return res.json();
            })
            .then((geo: GeoJsonObject) => {
              setDataMap((prev) => ({ ...prev, [key]: geo }));
            })
            .catch(() => {
              setDataMap((prev) => ({ ...prev, [key]: null }));
            });
        }
      } else {
        if (dataMap[key] !== null) {
          setDataMap((prev) => ({ ...prev, [key]: null }));
        }
      }
    });
  }, [layers]);

  return (
    <>
      {LAYER_CONFIGS.map(({ key, style }) => {
        const geo = dataMap[key];
        if (!layers.includes(key) || !geo) return null;

        return (
          <GeoJSON key={key} data={geo} style={(feature) => style(feature)} />
        );
      })}
    </>
  );
}
